import { IconPC, IconCode, IconMobile } from './Icons';
import ParticleBackground from './ParticleBackground';

const Services = () => {
  const services = [
    { 
      icon: <IconPC className="text-4xl" />, 
      title: "Website Design", 
      desc: "Stunning, modern websites that captivate your audience and drive conversions. We create responsive, SEO-optimized designs that reflect your brand's excellence." 
    },
    { 
      icon: <IconCode className="text-4xl" />, 
      title: "Custom Software", 
      desc: "Tailored software solutions built specifically for your business needs. From automation systems to data management platforms, we deliver powerful custom applications." 
    },
    { 
      icon: <IconMobile className="text-4xl" />, 
      title: "Mobile App", 
      desc: "Native and cross-platform mobile applications that engage users and deliver exceptional experiences on iOS and Android devices." 
    },
  ];

  return (
    <section id="services" className="w-full py-24 relative overflow-hidden" style={{ backgroundColor: '#111111' }}>
      {/* Particle Animation Background */}
      <ParticleBackground />
      
      {/* Subtle Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/10 via-transparent to-cyan-900/10"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/30">
            <span className="text-purple-400 text-sm font-semibold">RPS Digital Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What Services <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">We Offer</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">Comprehensive digital solutions tailored to your business needs</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="group relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-700 hover:border-purple-500/50 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl cursor-pointer"
            >
              {/* Hover Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/0 to-purple-500/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="relative z-10">
                <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-purple-500/50">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white group-hover:text-purple-300 transition-colors">{service.title}</h3>
                <p className="text-gray-300 mb-6 leading-relaxed">{service.desc}</p>
                <a href="#" className="text-purple-400 font-semibold hover:text-purple-300 flex items-center gap-2 group-hover:gap-3 transition-all">
                  Learn More <span className="group-hover:translate-x-1 transition-transform">→</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

